/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import FilterDeviceBtn from '../Filter';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import GlobalContext from '../../../../components/Context/GloablContext';
import ManageDeviceExportFn from '../Export';
import { useDeleteDeviceMutation } from '../../../../features/deviceSlice';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';

const ManageDeviceTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    isChangeStatusOPen,
    setIsChangeStatusOpen,
    username,
    setMultiDelete,
    handleCheckBox,
    searchDevice,
    handleStatusChangeModal,
    selectedStatus,
    isPatient,
    handleClearFilter,
    setIsAnyFieldFilled,
    setConfirmationState, data, exportDevice, isIdexport }) => {
    const [deleteDevice] = useDeleteDeviceMutation()
    const navigate = useNavigate()
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const fileInputRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState);
    const [dateError, setdateError] = useState(false)
    const ref = useRef()
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const dispatch = useDispatch()
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    // Function to handle onClick logic
    const handleSearchClick = () => {
            
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-list-devices');
        } else {
            setQueryParamsadmin('type=admin-list-devices');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
     
        // Check for reading_type, status, filter_start_date, and filter_end_date
        if ((searchParams.get("reading_type") !== null || searchParams.get("status") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
            setFilterValues((prevFilterValues) => ({
                ...prevFilterValues,
                ...filtervals,
                reading_type: searchParams.get("reading_type")?.split(',') || [],
                status: searchParams.get("status")?.split(',') || [], // Convert status string to an array
            }));
            
        } else if (searchParams.get("reading_type") === null && searchParams.get("status") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            setFilterValues({
                "filter_start_date": '',
                "filter_end_date": '',
                'reading_type': [],
                'status': [],
            });
        }
    
        setIsFilterOpen(!isFilterOpen);
    };
    
    const activesameStatus = selectedRows.every(obj => obj?.status === 'active');
    const retiredsameStatus = selectedRows.every(obj => obj?.status === 'retired');
    const outofservicesameStatus = selectedRows.every(obj => obj?.status === 'out-of-service');    
    
    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex items-center'>
                {title !== undefined ?
                    <h1 className={`text-xl font-normal text-[#000000] self-center min-w-max`}>{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    (userType !=='super-admin' && isPatient===undefined) &&
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-fit cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>
        
            <div className="flex items-start w-fit justify-end relative 2xl:flex-nowrap flex-wrap">
                {menuBar &&isPatient===undefined&& <div className='relative'>
                    <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] mr-2.5 hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                        onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false) }}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    >
                        {
                            isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                        }
                    </button>
                    {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 lg:left-[-20px] bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                       
                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                        <li>
                            <ul>
                                
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => {handleStatusChangeModal('active') ,setIsChangeStatusOpen(false) }}
                                        buttonName={"Activate"}
                                        disabled={activesameStatus || selectedRows.length === 1 && selectedRows[0].status === 'active'}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} disabled:text-[#6e6d6d]  `} />
                                </li>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => {handleStatusChangeModal('retired') ,setIsChangeStatusOpen(false) }}
                                        buttonName={"Retire"}
                                        disabled={retiredsameStatus || selectedRows.length === 1 && selectedRows[0].status === 'retired'}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} disabled:text-[#6e6d6d] `} />
                                </li>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => {handleStatusChangeModal('out-of-service') ,setIsChangeStatusOpen(false) }}
                                        buttonName={"Out of Service"}
                                        disabled={outofservicesameStatus || selectedRows.length === 1 && selectedRows[0].status === 'out-of-service'}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} disabled:text-[#6e6d6d]`} />
                                </li>
                            </ul>
                        </li>
                        <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Delete Devices</li>
                        <li>
                            <ul>
                                <li>
                                    <AnimatedButton
                                        handleClick={(e) => {setMultiDelete(true) ,setIsChangeStatusOpen(false)}}
                                        buttonName={"Delete"}
                                        disabled={deleteLoading}
                                        className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} `} />
                                </li>
                            </ul>
                        </li>
                    </ul>}

                    
                </div>}
                {SearchInput && !isPatient && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                {isPatient && 
                <div className="relative ml-2.5 2xl:mb-0 mb-2.5">
                    <label htmlFor="input"></label>
                    <input
                        maxLength={90}
                        type="text"
                        id="search-value"
                        autoComplete='off'
                        value={suggestions}
                        autoFocus={suggestions !== ''}
                        onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                        className="pl-10 pr-[31px] w-[295px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                    <button onClick={() => { setSuggestions(""); optimizedFn("") }}>
                        {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-2.5" />}
                    </button>
                </div>
                }
                {SearchInput && !searchDevice &&
                <div className="relative ml-2.5 2xl:mb-0 mb-2.5">
                    <label htmlFor="input"></label>
                    <input
                        maxLength={90}
                        type="text"
                        id="search-value"
                        autoComplete='off'
                        value={suggestions}
                        autoFocus={suggestions !== ''}
                        onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                        className="pl-10 pr-[31px] w-[295px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                    <img src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                    <button onClick={() => { setSuggestions(""); optimizedFn("") }}>
                        {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-2.5" />}
                    </button>


                    {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                            <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                        </button> --> */}

                </div>
                }
                {(ApplyFilter !== undefined && ApplyFilter) &&
                    <FilterDeviceBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        setIsAnyFieldFilled={setIsAnyFieldFilled}
                        handleClearFilter={handleClearFilter}
                        handleCheckBox={handleCheckBox}
                        isPatient={isPatient}
                        handleOpenFilter={handleOpenFilter} />
                }
                {SearchInput &&isPatient===undefined&& data !== undefined && data?.data?.length > 0 && <div>  
                    <ManageDeviceExportFn
                        selectedRows={selectedRows}
                        exportDevice={exportDevice}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} username={username} />
                </div>}
                {AddButton &&isPatient===undefined&&
                    <>{<Link to={path} state={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search_mode':searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}}>
                        <button type='button'
                            id="Add user"
                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 xl:mb-0 mb-2.5 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            {buttonName}
                        </button>
                    </Link>}</>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
            
            
            </div>
        </div>
    );
}

export default ManageDeviceTopBar;
